import React, {PropTypes} from "react";
import PersonalDataConfigurationFields from "./PersonalDataConfigurationFields";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../../../utils/data/dataActions";
import {
    CLIENT_V2,
    PERSONAL_DATA_CONFIGURATION,
    PERSONAL_DATA_CONFIGURATION_FIELDS,
    PERSONAL_DATA_CONFIGURATION_MESSAGES,
 PERSONAL_DATA_FORM } from "../../../../../utils/data/models";
import { toCamelCase , toSnakeCase } from "../../../../common/form/DBEnumStringHelper";
import { RectangleSpinner } from "../../../../common/spinners";

import {EN, FR} from "../../../../common/enums/languages";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { isSimpleFetchToast } from "../../../../common/RouteValidators/ClientValidationHelper";


class PersonalDataConfiguration extends React.Component {
    /**
     * Component that will pass down the form logic to the form.
     */
    constructor(props, context) {
        super(props, context);
        this.updateConfiguration = this.updateConfiguration.bind(this);
        this.updateMessageConfiguration = this.updateMessageConfiguration.bind(this);
        this.updateConfigurationClientField = this.updateConfigurationClientField.bind(this);

        this.state = {
            fetching: true,
            /**
             * This state is necessary in order not to send incomplete initialValues to reduxForms
             * (which can cause it to not refresh the initialValues, or even if they're refreshed,
             * it will look visually buggy.)
             */
        };
    }

    componentWillMount() {
        const { clientId, dataActions } = this.props;
        dataActions.getDataItem(PERSONAL_DATA_CONFIGURATION, clientId).then(() => {
            this.setState({ fetching: false });
        });
    }

    componentWillUnmount() {
        this.props.dataActions.clearDataList(PERSONAL_DATA_CONFIGURATION);
    }

    updateConfiguration(event) {
        const { dataActions, clientId } = this.props;

        if (event.target) {
            const field = event.target.name;
            const fieldToUpperCase = toSnakeCase(field);
            const checked = event.target.checked;
            const values = { clientId, [fieldToUpperCase.toUpperCase()]: checked };

            dataActions.updateDataItem(PERSONAL_DATA_CONFIGURATION_FIELDS, values).then(() => {
                /**
                 * Refresh form data after updating each field.
                 */
                dataActions.getDataItem(PERSONAL_DATA_CONFIGURATION, clientId);
            });
        }
    }

    updateConfigurationClientField(event) {
        const { dataActions, clientId } = this.props;
        const model = {path: PERSONAL_DATA_FORM.path.replace("{}", clientId)};

        if (event.target) {
            const field = event.target.name;
            const checked = event.target.checked;

            const values = { clientId, [field]: checked };
            dataActions.simplePost({model, data: values}).then(() => {
                this.props.dataActions.getDataItem(CLIENT_V2, clientId);
            });
        }
    }

    updateMessageConfiguration(formValues) {
        this.saveMessageForm(formValues);
    }

    saveMessageForm(formValues) {
        const clientId = this.props.clientId;
        const dataToUpdate = { clientId, ...formValues };
        this.props.dataActions.updateDataItem(PERSONAL_DATA_CONFIGURATION_MESSAGES, dataToUpdate).then((res) => {
            const simpleFetchToast = isSimpleFetchToast(res);

            if(!simpleFetchToast) {
                if(res.type === "UPDATE_DATA_ITEM_FAILURE") {
                    toast(
                        <FormattedMessage id="genericSaveError"/>,
                        {
                          type: toast.TYPE.ERROR,
                          autoClose: false
                        }
                      );
                }
                else{
                    this.props.dataActions.getDataItem(PERSONAL_DATA_CONFIGURATION, clientId);
                }
            }
        });
    }

    render() {
        const { clientId, personalDataConfiguration, clientStatusType } = this.props;
        const { fetching } = this.state;
        return !fetching ? (
            <PersonalDataConfigurationFields
                ref="form"
                clientId={clientId}
                onChange={this.updateConfiguration}
                clientStatusType={clientStatusType}
                initialValues={personalDataConfiguration}
                onClientFieldChange={this.updateConfigurationClientField}
                updateMessageConfiguration={this.updateMessageConfiguration}
            />
        ) : (
            <RectangleSpinner />
        );
    }
}

PersonalDataConfiguration.propTypes = {
    clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dataActions: PropTypes.object,
    personalDataConfiguration: PropTypes.object,
    clientStatusType: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

function mapStateToProps(state) {
    const activeClient = state.data.clients.active;
    const { clientId, hasPersonalDataForm, hasPersonalDataFormMessage, hasPersonalDataPopupMessage, clientStatusType } = activeClient;

    const personalDataConfig = state.data.personalDataConfiguration;
    let personalDataConfiguration = {
        hasPersonalDataForm,
        hasPersonalDataFormMessage,
        hasPersonalDataPopupMessage,
    };

    if (personalDataConfig && Object.keys(personalDataConfig).length > 0) {
        let localizations = {};

        if (personalDataConfig.active.hasOwnProperty("memberPersonalDataLocalizations")) {
            const memberPersonalDataLocalizations = personalDataConfig["active"]["memberPersonalDataLocalizations"]; // array of objs.

            if (memberPersonalDataLocalizations.length > 0) {
                memberPersonalDataLocalizations.forEach((obj) => {
                    const languageCode = obj["languageCode"];
                    const configMessage = obj["configMessage"];
                    const infoTitle = obj["infoTitle"];
                    const infoMessage = obj["infoMessage"];

                    localizations[languageCode] = { configMessage, infoTitle, infoMessage }; // We only have 2 elements in this array, one for english and another for french,
                });

            }
            else {
                localizations[EN.value] = {};
                localizations[FR.value] = {configMessage: "", infoTitle: "", infoMessage: ""};
            }
            personalDataConfiguration["localizations"] = localizations;
        }

        if (personalDataConfig.active.hasOwnProperty("memberPersonalDataFields")) {

            const memberPersonalDataFields = personalDataConfig["active"]["memberPersonalDataFields"]; // array of objs.

            memberPersonalDataFields.forEach((obj) => {
                /**
                 * We need to extract the field name from API response. Since the fields do not represent the keys (our typical API responses),
                 * reduxForms won't be able to interpret them unless we change the structure programatically.
                 */
                let field = obj["field"];
                field = toCamelCase(field);
                personalDataConfiguration[field] = true;
                /**
                 * This personalDataConfiguration object will be sent as the initialValues (reduxForms) prop in order to show the saved checkbox values from db in the fields component.
                 */
            });
        }
    }

    return {
        clientId: clientId,
        personalDataConfiguration,
        clientStatusType
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDataConfiguration);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/personal-data-configuration/PersonalDataConfiguration.js